function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "arrow-first"
}, React.createElement("path", {
  id: "arrow-border",
  d: "M0.5,0.5 L0.5,29.5 L119.813943,29.5 L136.599392,15 L119.813943,0.5 L0.5,0.5 Z",
  stroke: "#E2E1E4"
}), React.createElement("polygon", {
  id: "inner-background",
  fill: "#FFFFFF",
  points: "1 1 119.619531 1 136 15 119.619531 29 1 29"
}), React.createElement("path", {
  id: "outer-fill",
  d: "M137.433777,0 L137.364594,15.0026855 L119.999039,0 L137.433777,0 Z M137.425375,30 L120,30 L137.356229,15 L137.425375,30 Z",
  fillOpacity: 0,
  fill: "#FFFFFF"
})));

var SvgStatusArrowStart = function SvgStatusArrowStart(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "138px",
    height: "30px",
    viewBox: "0 0 138 30",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStatusArrowStart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status-arrow-start.2982e550.svg";
export { ForwardRef as ReactComponent };